import React from 'react';


const ConsentContent = () => {
    return (
        <div>
            <p>
                This <span style={{ color: '#0070C0' }}>pilot mobility services in Greene County (named rural mobility service platform: RAMP)</span> is part of a research study conducted by <span style={{ color: '#0070C0' }}>Dr. Sean Qian</span> at Carnegie Mellon University <strong>in partnership with Greene County Transportation Services, Blueprints, and Waynesburg University and is funded by the U.S. Department of Energy</strong>.
            </p>
            <p>
                <span style={{ color: '#0070C0' }}>
                    Two new transportation services—a fixed-route shuttle service and an on-demand flex-route shuttle service—are being operated to make it easier and more affordable for people to travel within, to, and from Greene County. The goal is to address the mobility need for Greene residents, to improve access to essential resources: food, healthcare, jobs and community services.
                </span>
            </p>
            <p style={{ marginBottom: '0px' }}>
                <strong>Purpose</strong>
            </p>
            <p>
                <span style={{ color: '#0070C0' }}>
                    Through this pilot, we would like to test the effectiveness of mobility service models and software, and understand where, when and how residents in Greene County would use this service to make trips, so we can recommend best service offerings in the near future for Greene County. This pilot study also learns lessons from practices to potentially deploy this service in other rural areas in the country.
                </span>
            </p>
            <p style={{ marginBottom: '0px' }}>
                <strong>Procedures</strong>
            </p>
            <p>
                <span style={{ color: '#0070C0' }}>
                    Any citizen in Greene County, including students, staff and faculty in Waynesburg University, who decide to ride on RAMP, will first sign the signup and consent agreement form. Then you can call in or use the web application to request the riding service. Depending on how the system optimizes all rides at the same time, your request may be responded with: either 1) a shuttle vehicle will arrive to pick you up and drop you off; or 2) a recommendation to take fixed route transit and possibly a follow-up instruction to be picked up at the destination stop. You can request as many rides as you need during the pilot period. Depending on where your destination is, the expected duration is estimated to be 10min to 120min long for each ride. 
                </span>
            </p>
            <p>
                <span style={{ color: '#0070C0' }}>
                    Trip data (origin, destination and trip duration) will be collected for each ride, strictly for research purposes. In addition, rider data (phone number, email address and payment information) are only used to operate this service, those data will not be used in our project and will be kept strictly confidential, stored in the cloud server only. In addition, all shuttle vehicles have dash cameras that record video for safety. Those video data are not for the research, and will be completely deleted after the pilot study.
                </span>
            </p>
            <p style={{ marginBottom: '0px' }}>
                <strong>Participant Requirements</strong>
            </p>
            <p>
                Participation in this study is limited to individuals age 18 and older. <span style={{ color: '#0070C0' }}>Your trip purpose needs to be essential, defined as one of the followings: food, healthcare, jobs and community services. You must be a resident of Greene County, or an enrolled student, staff or faculty at Waynesburg University since 8/1/2023.</span>
            </p>
            <p style={{ marginBottom: '0px' }}>
                <strong>Risks</strong>
            </p>
            <p>
                The risks and discomfort associated with participation in this study are no greater than those ordinarily encountered when taking public transit or Uber/Lyft services. <span style={{ color: '#0070C0' }}>You are expected to pay for your rides using a personal account, which is set up along with the signup and consent process. Your account will contain personal information and possibly financial information, just like an account to use Uber/Lyft service. The web application is software engineered to ensure all transactions are secure and encrypted.</span>
            </p>
            <p>
                <span style={{ color: '#0070C0' }}>
                    Though the software engineering team does its best within the budget and time frame of this project to ensure account safety, there is always a possibility that those accounts may be subject to malicious cyber-attacks. Attackers may hack those personal accounts, and data consisting of user names, phone numbers, and trip information, under those cyber-attacks, may be breached. 
                </span>
            </p>
            <p style={{ marginBottom: '0px' }}>
                <strong>Benefits</strong>
            </p>
            <p>
                A direct benefit for the participants is that you are able to reach to their desired destinations much faster, easier and without using their own private vehicle. In addition, the knowledge received to the research team may help improve the rural mobility service and be of value to the entire rural community.  
            </p>
            <p style={{ marginBottom: '0px' }}>
                <strong>Compensation & Costs</strong>
            </p>
            <p>
                There is no compensation for participation in this study. The cost to use RAMP follows the standard PennDOT guideline. 
            </p>
            <p>
                <span style={{ color: '#0070C0' }}>
                    <table>
                        <tr>
                            <th>Miles</th>
                            <th>Price (one way)</th>
                        </tr>
                        <tr>
                            <td>0-1.99</td>
                            <td>$2.25</td>
                        </tr>
                        <tr>
                            <td>2-3.99</td>
                            <td>$2.85</td>
                        </tr>
                        <tr>
                            <td>4-6.99</td>
                            <td>$3.60</td>
                        </tr>
                        <tr>
                            <td>7-11.99</td>
                            <td>$4.80</td>
                        </tr>
                        <tr>
                            <td>12-19.99</td>
                            <td>$5.70</td>
                        </tr>
                        <tr>
                            <td>20-24.99</td>
                            <td>$6.45</td>
                        </tr>
                        <tr>
                            <td>25 and up</td>
                            <td>$7.50</td>
                        </tr>
                    </table>
                </span>
            </p>
            <p style={{ marginBottom: '0px' }}>
                <strong>Future Use of Information</strong>
            </p>
            <p>
                In the future, once we have removed all identifiable information from your data (information of your travel time and locations), we may use the data for our future research studies to optimize mobility services in Greene County.  The data, however, will be kept strictly within CMU for research purposes. We will never share the data with anyone else other than CMU researchers who are actively working on this study. Sharing of data among CMU researchers will only be done in such a manner that you will not be identified.
            </p>
            <p style={{ marginBottom: '0px' }}>
                <strong>Confidentiality</strong>
            </p>
            <p>
                By participating in this research, you understand and agree that Carnegie Mellon may be required to disclose your consent form, data and other personally identifiable information as required by law, regulation, subpoena or court order.  Otherwise, your confidentiality will be maintained in the following manner:
            </p>
            <p>
                Your data and consent form will be kept separate. Your research data will be stored in a secure location on CMU property or via secure electronic means and in the control of CMU, and will not be disclosed to third parties. By participating, you understand and agree that the data and information gathered during this study may be used by Carnegie Mellon and published.  However, your name, address, contact information and other direct personal identifiers will not be mentioned in any such publication or dissemination of the research data and/or results by Carnegie Mellon. Note that per regulation all research data must be kept for a minimum of 3 years.
            </p>
            <p>
                <span style={{ color: '#0070C0' }}>
                    The study is sponsored by U.S. Department of Energy, but the sponsor will not have access to research records.
                </span>
            </p>
            <p style={{ marginBottom: '0px' }}>
                <strong>Right to Ask Questions & Contact Information</strong>
            </p>
            <p>
                If you have any questions about this study, you should feel free to ask them by contacting the Principal Investigator now at <span style={{ color: '#0070C0' }}>Dr. Sean Qian, Department of Civil and Environmental Engineering, Carnegie Mellon University, 5000 Forbes Ave, Pittsburgh PA 15213, 412-268-4155, seanqian@cmu.edu</span>. If you have questions later, desire additional information, or wish to withdraw your participation please contact the Principal Investigator by mail, phone or e-mail in accordance with the contact information listed above.
            </p>
            <p>
                If you have questions pertaining to your rights as a research participant; or to report concerns to this study, you should contact the Office of Research integrity and Compliance at Carnegie Mellon University.  Email: <a href='mailto:irb-review@andrew.cmu.edu'>irb-review@andrew.cmu.edu</a>. Phone: 412-268-4721.
            </p>
            <p style={{ marginBottom: '0px' }}>
                <strong>Voluntary Participation</strong>
            </p>
            <p>
                <strong>
                    I understand that by utilizing this transportation service I am voluntarily participating in this transportation study. I understand that I may decline this service at any time, without giving a reason and without cost. I understand that information from my participation will be utilized as a part of a transportation research project. I understand that my personal information will not be shared. I understand that this transportation study is being conducted by Carnegie Mellon University in partnership with Greene County Transportation Services, Blueprints, and Waynesburg University and is funded by the U.S. Department of Energy.
                </strong>
            </p>
            <p>
                You may print a copy of this consent form for your records. 
            </p>
        </div>
    );
};


export default ConsentContent;
